/**
 * Decides where the global `not-found` page should send the user.
 *
 * The app has no page at the root `/` other than the locale tree, and unknown
 * paths are intentionally bounced home. But doing that UNCONDITIONALLY is a
 * loop hazard: if `/` (or a bare locale root) ever resolves to not-found, then
 * `not-found -> redirect("/") -> not-found -> ...` recurses through the client
 * router until the call stack overflows. This guard returns `null` for
 * root-like paths so the page renders a recovery fallback instead of looping.
 *
 * See Sentry CUSTOMER-UI-3T (the `RangeError: Maximum call stack size exceeded`
 * failure class) — this is defense-in-depth alongside the AuthController fix.
 */

// A bare locale root such as "/", "/en-GB", "/es", "/en-GB/".
const LOCALE_ROOT = /^\/[a-z]{2}(-[A-Z]{2})?\/?$/;

export function notFoundRedirectTarget(pathname: string): "/" | null {
  if (pathname === "" || pathname === "/" || LOCALE_ROOT.test(pathname)) {
    return null;
  }
  return "/";
}
